import { useCallback } from "react";
import {
  useUpsertUserNoteMutation,
  useUserNotesQuery,
} from "@/features/workspace/graphql/generated";

type UpsertTeamNoteInput = {
  note: string;
  type: string;
  id?: number;
};

export const usePersonalNotes = (personId: number) => {
  const { data, loading, error } = useUserNotesQuery({
    variables: {
      filter: {},
    },
  });

  const notes = data?.userNotes;

  const [upsertUserNote] = useUpsertUserNoteMutation();

  const handleUpsertUserNote = useCallback((input: UpsertTeamNoteInput) => {
    upsertUserNote({
      variables: {
        note: input.note,
        type: input.type,
        id: input.id || null,
      },
    });
  }, []);

  const handleDeleteUserNote = useCallback(
    (id: number, type: string) => {
      handleUpsertUserNote({
        note: "",
        type,
        id,
      });
    },
    [handleUpsertUserNote]
  );

  return {
    notes,
    loading,
    error,
    handleUpsertUserNote,
    handleDeleteUserNote,
  };
};
